import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { UploadedFileMetadataUpdateInput, UploadedFileMetadataUpdatePayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = UploadedFileMetadataUpdateInput;
type TData = UploadedFileMetadataUpdatePayload;

export const useUploadedFileMetadataUpdate = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation uploadedFileMetadataUpdate($input: UploadedFileMetadataUpdateInput!) {
      uploadedFileMetadataUpdate(input: $input) {
        success
        errors

        file {
          metadata
        }
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
